// extracted by mini-css-extract-plugin
export default {"container":"DesktopSideBar_container__z-pt4"};